import { useContext } from 'react';

import historyOfChangesContext from '../contexts/history-of-changes-context';

export default function useHistoryOfChangesContext() {
    return useContext(historyOfChangesContext);
}
